// extracted by mini-css-extract-plugin
export default {"items":"Swatch_items__b3exG","wrap":"Swatch_wrap__wzZAB"};